export default {
  searched: []
}